<div>
    <div class="row ">
      <div class="col pl-3">
        <h4 class="mb-0 font-header" style="font-weight: 700;" ><label (click)="MovetoClientParent()"><i
            title="Close"  class="fa fa-chevron-circle-left" style="font-size:24px" title="Close"></i></label>&nbsp;Client Report</h4>
      </div>
    </div>
    <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
      <div class="row mt-4 ">
          <div class="col ">
              <div widget class="card border-0 box-shadow">
                  <div class="card-body  widget-body pt-2">
                      <div class="text-center text-danger">
                          <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                              agency to view
                              details</label>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
 <!-- list -->
<div class="row mt-4" *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
    <div class="col ">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
                <div class="row">
                    <div class="ml-auto">
                        <button class="btn blue-btn btn-sm mr-2" type="button"(click)="generateLastDateReport()"
                        >Last Date Of Service</button>&nbsp;&nbsp;
                        
                            <button type="button" class="btn blue-btn btn-sm  ml-1"
                            [disabled]=" !isEnabledExcel" (click)="exportClientReportCsv()">
                            <i class="fa fa-file-excel-o mr-1"></i>Export</button>&nbsp;&nbsp;
                            <button class="btn blue-btn btn-sm mr-2" type="button"(click)="inactiveClientrecord()"
                             >Inactive Client</button>&nbsp;&nbsp;
                             <button class="btn blue-btn btn-sm mr-2" type="button"(click)="sdprecordModal()"
                             >SDP Report</button>
                    </div>
                </div>
                <div class="row mt-2 ">
                    <div class="col-lg-4 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Client Type</label>
                        </div>
                        <div class="col-lg-12 d-inline-flex">
                            <ng-select [(ngModel)]="clienttypeLid" class="w-100 " [searchable]="true" [clearable]="true"
                                [items]="TypeofClient" bindLabel="lovName" bindValue="id"></ng-select>
                            <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('CLIENTTYPE')"></app-dropdown>
                        </div>
                    </div>
                    <div class="col-lg-4 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Status </label>
                        </div>
                        <div class="col-lg-12 d-inline-flex">
                            <ng-select class="w-100" [(ngModel)]="ReportstatusLid" [searchable]="true"
                                [clearable]="true" [items]="ClientStatusList" bindLabel="lovName"
                                bindValue="id"></ng-select>
                            <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('STATUS')"></app-dropdown>
                        </div>
                    </div>
                    <div class="col-lg-4 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Gender </label>
                        </div>
                        <div class="col-lg-12 d-inline-flex">
                            <ng-select class="w-100" [(ngModel)]="genderLid" [searchable]="true" [clearable]="true"
                                [items]="genderList" bindLabel="lovName" bindValue="id">
                            </ng-select>
                            <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('GENDER')"></app-dropdown>
                        </div>
                    </div>
                </div>
                <div class="row mt-2 mb-3">
                    <div class="col-lg-4 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Employee</label>
                        </div>
                        <div class="col-lg-12 v">
                            <ng-select class="w-100" [(ngModel)]="employeeId" [searchable]="true" [clearable]="true"
                                [items]="QpEmployeeDropDown" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                    </div> 
                    <div class="col-lg-4 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Type of Waiver</label>
                        </div>
                        <div class="col-lg-12 d-inline-flex">
                            <ng-select class="w-100" [(ngModel)]="typeofWaiverLid" [searchable]="true"
                                [clearable]="true" [items]="TypeofWaiver" bindLabel="lovName" bindValue="id">
                            </ng-select>
                            <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('TYPEOFWAIVER')"></app-dropdown>
                        </div>
                    </div> 
                                       
                        <div class="col-lg-4 pl-1">
                            <div class="col-lg-12">
                                <label style="font-weight:bold" class="mt-3"> </label>
                            </div>
                            <div class="col-lg-12 ">
                                <button type="button" class="btn blue-btn btn-sm" (click)="ApplyFilter()">Apply</button>&nbsp;&nbsp;
                                <button type="button" class="btn blue-btn btn-sm ml-2"
                                    (click)="ClearFilter()">Clear</button>&nbsp;&nbsp;
                                    <button class="btn blue-btn btn-sm ml-2" type="button" (click)="RefreshFilter()">
                                        <i class="fa fa-repeat"> </i>Refresh
                                    </button>
                            </div>
                        </div>
                    </div>
                
                <ejs-grid #gridClientReport [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true'
                    allowPaging='true' [allowFiltering]='true' [pageSettings]='initialPage'
                    [filterSettings]='filterOptions' (dataStateChange)='dataStateChange($event)'
                    (actionBegin)="onActionComplete($event)" (resizeStop)="onResize($event)" [showColumnChooser]='true'
                    [allowExcelExport]='true'>
                    <e-columns >
                        <e-column minWidth=150 width="100" field="clientName" headerText="Client Name" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=150 width="100" field="dob" headerText="DOB" type='date' [allowFiltering]='false'
                            [allowSorting]='false' [format]='formatOptions'>
                        </e-column>
                        <e-column minWidth=150 width="100" field="age" headerText="Age" type='number'></e-column>
                        <e-column minWidth=150 width="100" field="genderName" headerText="Gender" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=150 width="100" field="street" headerText="Street" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=80 width="100" field="apt" headerText="Apt" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=80 width="100" field="email" headerText="Email" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=80 width="100" field="language" headerText="Language" type='string' [allowFiltering]='false'
                        [allowSorting]='false'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100  width="100" field="caseManager" headerText="CaseManager Name" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="caseManagerEmail" headerText="CaseManager Email" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="careCoordinator" headerText="CareCoordinator Name" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100  width="100" field="careCoordinatorEmail" headerText="CareCoordinator Email"
                            type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="responsiblePartyName" headerText="Participant's Representative Name "
                        type='string' [allowFiltering]='false'  [allowSorting]='false'>
                        <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                    </e-column>
                        <e-column minWidth=100 width="100"  field="phone1" headerText="Phone1" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100"  field="phone2" headerText="Phone2" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=80 width="100" field="city" headerText="City" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=80 width="100" field="state" headerText="State" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=80 width="100" field="county" headerText="County" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=80 width="100" field="zipCode" headerText="ZIP Code" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="locationName" headerText="Location" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="cfssModel" headerText="CFSS Model" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="clientTypeName" headerText="ClientTypeName" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="statusName" headerText="Status" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-dropdownlist id='dropdown' placeholder='Select a Status'
                                    [dataSource]='ClientReportDropData' [popupHeight]='height'>
                                </ejs-dropdownlist>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="typeofWaiverName" headerText="WaiverTypeName" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="employeeNames" headerText="Employee Name" type='string'
                            [allowFiltering]='false' [allowSorting]='false'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column width="50" [showInColumnChooser]='false'>
                            <ng-template #headerTemplate let-data>
                                <div class="d-none d-lg-block">
                                    <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                        </i></span>
                                </div>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
                <div *ngIf="ClientReportList.length == 0" class="text-center" style="color:red">
                    <p>No data available</p>
                </div>
            </div>
        </div>
    </div>
</div>
  </div>
<!-- ClientBirthDayModal -->
<span id="openBirthDayModal" data-bs-toggle="modal" data-bs-target="#ClientBirthDayModal"></span>
<div class="modal fade" id="ClientBirthDayModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Client BirthDay Report</span>
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="clearModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5">
                        <label>Start Date&nbsp;<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <my-date-picker  placeholder="mm/dd/yyyy"
                            [selDate]="BirthDayReport.fromDate"
                            (inputFieldChanged)="BirthDayReportDateChanges($event,'inputchange','BirthDayfromDate')"
                            (dateChanged)="BirthDayReportDateChanges($event,'datechanged','BirthDayfromDate')">>
                        </my-date-picker>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-lg-5">
                        <label>End Date&nbsp;<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-7">
                        <my-date-picker  placeholder="mm/dd/yyyy"
                            [selDate]="BirthDayReport.endDate"
                            (inputFieldChanged)="BirthDayReportDateChanges($event,'inputchange','BirthDayEndDate')"
                            (dateChanged)="BirthDayReportDateChanges($event,'datechanged','BirthDayEndDate')">
                        </my-date-picker>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <!-- <button class="btn blue-btn btn-sm" [disabled]="BirthDayReport.fromDate==null || BirthDayReport.fromDate==undefined || BirthDayReport.fromDate=='' ||
          BirthDayReport.endDate==null || BirthDayReport.endDate==undefined || BirthDayReport.endDate=='' "
                    (click)="getClientBirthdayReport();" > <span>Generate Report</span> </button> -->
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="clearModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="OpenCBirthDayModal" data-bs-toggle="modal" data-bs-target="#CBirthDayModal"></span>
<div class="modal fade" id="CBirthDayModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">{{reptitle}}</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" (click)="closeGenerateModal()">
                        Close</button>
                </div>
            </div>
            <div class="modal-body" style="height:600px">
                <ng-container *ngIf="ViewReport== true">
                    <div style="width: 100%;height:100%" class="report-border" #reportContainer></div>
                    
                </ng-container>
            </div>
        </div>
    </div>
</div>


<span id="openinactive" data-bs-toggle="modal" data-bs-target="#inactiveModal"></span>
<div class="modal fade" id="inactiveModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog mw-100">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Inactive Client</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" (click)="InactiveClientModal()">
                        Close</button>
                </div>
            </div>
            <div class="modal-body" style="height:600px">
                <app-client-report-inactive *ngIf="isClientReportInactive">

                </app-client-report-inactive>
               
            </div>
        </div>
    </div>
</div>
<!-------------------------------------SDP Report Modal---->
<span id="openSDPReportModal" data-bs-toggle="modal" data-bs-target="#sdpreport"></span>
<div class="modal fade" id="sdpreport" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog mw-100">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">SDP Report</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" data-bs-dismiss="modal" (click)="clearSDPReport()">
                        Close
                    </button>
                </div>
            </div>
            <div class="modal-body" style="height:600px; overflow-y: auto;">
                <!-- SDP Report Content -->
                <div *ngIf="isSDPReportActive">
                    <!-- Date Filters Row -->
                    <div class="row mb-3">
                        <div class="col pl-0">
                            <div widget class="card border-0 box-shadow">
                                <div class="card-body widget-body pb-2 pt-2">
                                    <div class="row align-items-center g-3">
                                        <!-- From Date -->
                                        <div class="col-12 col-md-3">
                                            <label>From Date<sup class="super-script">*</sup></label>
                                            <my-date-picker 
                                                [options]="myDatePickerOptions"
                                                [selDate]="reportFromDate" 
                                                placeholder="mm/dd/yyyy"
                                                (inputFieldChanged)="onReportDateChanged($event, 'fromDate', 'input')"
                                                (dateChanged)="onReportDateChanged($event, 'fromDate', 'date')">
                                            </my-date-picker>
                                        </div>

                                        <!-- To Date -->
                                        <div class="col-12 col-md-3">
                                            <label>To Date<sup class="super-script">*</sup></label>
                                            <my-date-picker 
                                                [options]="myDatePickerOptions"
                                                [selDate]="reportToDate" 
                                                placeholder="mm/dd/yyyy"
                                                (inputFieldChanged)="onReportDateChanged($event, 'toDate', 'input')"
                                                (dateChanged)="onReportDateChanged($event, 'toDate', 'date')">
                                            </my-date-picker>
                                        </div>

                                        <!-- Search Button -->
                                        <div class="col-12 col-md-2">
                                            <button 
                                                type="button" 
                                                class="btn btn-sm mt-4"
                                                [disabled]="!reportFromDate || !reportToDate"
                                                (click)="searchSDPReport()">
                                                Apply
                                            </button>
                                        </div>

                                        <!-- Export CSV Button -->
                                        <div class="col-12 col-md-2">
                                            <button 
                                                type="button" 
                                                class="btn btn-sm mt-4"
                                                data-bs-toggle="modal" data-bs-target="#exportSDPascsvmodel">
                                                <i class="fa fa-download me-2"></i>Export CSV
                                            </button>
                                        </div>

                                        <!-- Refresh Button -->
                                        <div class="col-12 col-md-2">
                                            <button 
                                                type="button" 
                                                class="btn btn-sm mt-4"
                                                (click)="clearSDPReport()">
                                                <i class="fa fa-repeat me-2"></i>Refresh
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Grid Row -->
                    <div class="row mb-2">
                        <div class="col pl-0">
                            <div widget class="card border-0 box-shadow">
                                <div class="card-body widget-body pt-2">
                                    <ejs-grid 
                                        #sdpReportGrid 
                                        id="SDPReportGrid"
                                        [dataSource]='sdpData | async' 
                                        [allowResizing]='true' 
                                        [allowReordering]="true"
                                        [allowSorting]='true' 
                                        allowPaging='true' 
                                        [allowFiltering]='true'
                                        [pageSettings]='reportInitialPage'
                                        [filterSettings]='filterOptions'
                                        (actionComplete)="onSDPReportActionComplete($event)"
                                        [showColumnChooser]='true'
                                        [editSettings]='editSettings' 
                                        (dataStateChange)='sdpReportDataStateChange($event)' 
                                        (resizeStop)="onSDPReportResize($event)">
                                        
                                        <e-columns>
                                           
                                            <!-- SDP Uploaded -->
                                            <e-column field='isUploaded' headerText="SDP Uploaded" width=120
                                                textAlign='center' [allowEditing]='false'
                                                [allowSorting]='false' [allowFiltering]='false'>
                                                <ng-template #template let-data>
                                                    {{ data.isUploaded ? 'Yes' : 'No' }}
                                                </ng-template>
                                            </e-column>

                                            <!-- Client Name -->
                                            <e-column width=150 field="clientName" headerText="Client Name" 
                                                type="string" [allowEditing]='false'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>

                                            <!-- Start Date -->
                                            <e-column width=120 field="startdate" headerText="Start Date" 
                                                type="date" [allowEditing]='false' [allowFiltering]='false' 
                                                [format]="formatOptions">
                                            </e-column>

                                            <!-- End Date -->
                                            <e-column width=120 field="enddate" headerText="End Date" 
                                                type="date" [allowEditing]='false' [allowFiltering]='false' 
                                                [format]="formatOptions">
                                            </e-column>

                                            <!-- Model -->
                                            <e-column width=100 field="modeltypeName" headerText="Model" 
                                                type="string" [allowEditing]='false'>
                                            </e-column>

                                            <!-- Plan Type -->
                                            <e-column width=100 field="version" headerText="Plan Type" 
                                                type="string" [allowEditing]='false'>
                                            </e-column>

                                            <!-- Plan Date -->
                                            <e-column width=120 field="plandate" headerText="Plan Date" 
                                                type="date" [allowFiltering]='false' [allowEditing]='false' 
                                                [format]="formatOptions">
                                            </e-column>

                                            <!-- Created Date -->
                                            <e-column width=120 field="createdTime" headerText="Created Date" 
                                                type="date" [allowFiltering]='false' [allowEditing]='false' 
                                                [format]="formatOptions">
                                            </e-column>

                                            <!-- Modified Date -->
                                            <e-column width=120 field="modifiedTime" headerText="Modified Date" 
                                                type="date" [allowFiltering]='false' [allowEditing]='false' 
                                                [format]="formatOptions">
                                            </e-column>

                                            <!-- Created By -->
                                            <e-column width=120 field="createdBy" headerText="Created By" 
                                                type="string" [allowSorting]='false' [allowEditing]='false'>
                                            </e-column>

                                            <!-- Modified By -->
                                            <e-column width=120 field="modifiedBy" headerText="Modified By" 
                                                type="string" [allowSorting]='false' [allowEditing]='false'>
                                            </e-column>

                                            <!-- Settings Icon -->
                                            <e-column width="50" [showInColumnChooser]='false'>
                                                <ng-template #headerTemplate let-data>
                                                    <div>
                                                        <span id='showSDPReport'>
                                                            <i class="fa fa-cog fa-lg" aria-hidden="true" 
                                                                (click)='showSDPReportColumnChooser()'></i>
                                                        </span>
                                                    </div>
                                                </ng-template>
                                            </e-column>
                                        </e-columns>
                                    </ejs-grid>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Modal for Export CSV -->
<span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportSDPascsvmodel"></span>
<div class="modal fade" id="exportSDPascsvmodel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Export as CSV</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-6">
            <button class="btn btn-primary btn-sm mb-1" (click)="exportSDPWithPaginationCsv()">
              Print Current page
            </button>
          </div>
          <div class="col-lg-6">
            <button class="btn btn-primary btn-sm mb-1" (click)="exportSDPAll()">
              Print All pages
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
                </div>
            </div>
        </div>
    </div>
</div>

